import { usePathname } from '@/i18n/routing';

type MatchMode = 'segment' | 'exact';

export const useIsThisPage = (page: string, match: MatchMode = 'segment'): boolean => {
  const pathname = usePathname();

  if (match === 'exact') {
    return pathname === page;
  }

  return pathname.includes(page);
};
